import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_comp_einvoice_printable_format_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  printable_format_hdr_guid: fromDatatype.GuidDataFieldInterface;
  header: fromDatatype.TextDatatypeInterface;
  footer: fromDatatype.TextDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
}

export class bl_fi_mst_comp_einvoice_printable_format_hdr_RowClass implements bl_fi_mst_comp_einvoice_printable_format_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  printable_format_hdr_guid: fromDatatype.GuidDataFieldInterface;
  header: fromDatatype.TextDatatypeInterface;
  footer: fromDatatype.TextDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
}
